import React from "react";
import "./InvestorCard.scss"
const InvestorCard = ({ item }) => {
    return (
        <div className="InvestorCard">
            <img alt="" src={item.icon} className="InvestorCard-icon" />
            <div className="InvestorCard-header">
                {item.header}
            </div>
            <div className="InvestorCard-subheader">
                {item.content}
            </div>
        </div>
    )
}
export default InvestorCard